export default "__VITE_ASSET__BskiVYvm__"